module.exports = __webpack_public_path__ + "img/12.dab1f8d3.jpg";